import ClientComponent from './client-component';
import ClientRow from '../client-row/client-row';

/***
 * A single row in a client-list.
 */
const client = angular
    .module('FacilityData.ClientAdmin.Client', [
        ClientRow
    ])
    .component('client', ClientComponent)

    .name;

export default client;


// WEBPACK FOOTER //
// ./app/components/client-admin/client/client.js